var React = require('react');

function LgLineInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M286.172 2.50179e-05L291.172 5L286.172 10L0 10V0L286.172 2.50179e-05ZM291.828 2.55125e-05L295.414 3.58579L296.828 5L295.414 6.41421L291.828 10L574 10.0001V5.01807e-05L291.828 2.55125e-05Z","fill":"#E2E6EC"}));
}

LgLineInline.defaultProps = {"width":"574","height":"10","viewBox":"0 0 574 10","fill":"none"};

module.exports = LgLineInline;

LgLineInline.default = LgLineInline;
